import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFloor1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 33,
	viewBox: "0 0 29 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 22.8206,
			width: 29,
			height: 9.66667,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.23077,
			y: 25.7949,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1538,
			y: 25.7949,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20.0769,
			y: 25.7949,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 11.6666,
			width: 29,
			height: 9.66667,
			fill: "var(--rs-theme)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.23077,
			y: 14.641,
			width: 6.69231,
			height: 6.69231,
			fill: "var(--rs-theme-lighter)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1538,
			y: 14.641,
			width: 6.69231,
			height: 6.69231,
			fill: "var(--rs-theme-lighter)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20.0769,
			y: 14.641,
			width: 6.69231,
			height: 6.69231,
			fill: "var(--rs-theme-lighter)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: .512817,
			width: 29,
			height: 9.66667,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.23077,
			y: 3.48718,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1538,
			y: 3.48718,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20.0769,
			y: 3.48718,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		})
	]
});
export default SvgIconFloor1;
